<template>
  <header class="c-mobile-header">
    <div class="header-inner">
      <div class="logo-wrap">
        <img :src="logo" alt="Logo" class="logo"/>
      </div>

      <div class="header-actions">
        <div class="company-selector" v-if="companies.length > 0">
          <div class="company-select-wrap" @click="toggleDropdown">
            <span class="company-selected-title">{{ selectedCompanyTitle }}</span>
            <svg
                class="company-chevron"
                :class="{ 'company-chevron--open': isOpen }"
                width="16" height="16" viewBox="0 0 16 16" fill="none"
            >
              <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </div>

          <transition name="dropdown">
            <div class="company-dropdown" v-if="isOpen">
              <div
                  v-for="company in companies"
                  :key="company.id"
                  class="company-dropdown-item"
                  :class="{ 'company-dropdown-item--active': company.id === selectedCompanyId }"
                  @click="selectCompany(company)"
              >
                <span>{{ company.title }}</span>
                <svg v-if="company.id === selectedCompanyId" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8l4 4 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import logo from '/src/assets/logo.png'

export default {
  name: "CMobileAppHeader",
  data() {
    return {
      logo,
      isOpen: false,
      companies: [],
      user: null,
      selectedCompanyId: null,
    }
  },
  computed: {
    userId() {
      return this.$store.state.auth.user?.id
    },
    selectedCompanyTitle() {
      const found = this.companies.find(c => c.id === this.selectedCompanyId)
      return found ? found.title : '—'
    },
  },
  async created() {
    await this.fetchUser()
    await this.fetchCompanies()
    this.selectedCompanyId = this.user?.selectedCompany ?? null

    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    async fetchUser() {
      try {
        await $api.auth.info()
            .then((response) => {
              if (response && response.data.content) {
                this.user = response.data.content.user
              }
            }).catch((error) => {})
      } catch (error) {
        console.error('Ошибка загрузки пользователя', e)
      }
    },
    async fetchCompanies() {
      try {
        const response = await $api.users.getMyCompanies(this.userId)
        if (response?.data?.data) {
          this.companies = response.data.data
        }
      } catch (e) {
        console.error('Ошибка загрузки компаний', e)
      }
    },
    async selectCompany(company) {
      if (company.id === this.selectedCompanyId) {
        this.isOpen = false
        return
      }

      try {
        this.selectedCompanyId = company.id
        await $api.users.changeSelectedCompany(this.selectedCompanyId)
            .then(() => {
              window.location.reload()
            });
        this.isOpen = false
        this.$emit('update:show', false)
      } catch (e) {
        console.error('Ошибка смены компании', e)
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen
    },

    handleOutsideClick(e) {
      if (!this.$el.querySelector('.company-selector')?.contains(e.target)) {
        this.isOpen = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.c-mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  padding-top: env(safe-area-inset-top);
  background: #fafafa;
  border-bottom: 1px solid #ccc;
  z-index: 1001;
}

.header-inner {
  height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo {
  height: 70px;
  width: 100px;
}

.header-actions {
  min-width: 24px;
}

/* Company selector */
.company-selector {
  position: relative;
}

.company-select-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #f0f0f0;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;

  &:active {
    background: #e0e0e0;
  }
}

.company-selected-title {
  font-size: 13px;
  font-weight: 500;
  color: #1c1c1c;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-chevron {
  color: #888;
  transition: transform 0.2s;
  flex-shrink: 0;

  &--open {
    transform: rotate(180deg);
  }
}

.company-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  z-index: 100;
}

.company-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px;
  font-size: 14px;
  color: #1c1c1c;
  cursor: pointer;
  transition: background 0.15s;

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }

  &:active {
    background: #f5f5f5;
  }

  &--active {
    color: #4a90e2;
    font-weight: 500;

    svg {
      color: #4a90e2;
    }
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.15s, transform 0.15s;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>